import React from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';
import { Link } from 'react-router-dom';
import { Mail, ExternalLink } from 'react-feather';

const Footer: React.FC = () => {
	return (
		<div className="w-full bg-gradient-to-br from-[#4660ff] via-[#5a75ff] to-[#6e8aff]">
			<div className="flex flex-col md:flex-row w-full md:w-4/5 mx-auto p-8 md:p-12 gap-8 md:gap-12">
				<div className="flex-1">
					<div className="flex flex-col gap-6">
						<div className="mb-2">
							<Typography color="white" size={20} weight="bold">
								Finanzas Incluyentes para Todos.
							</Typography>
						</div>
						<div className="flex flex-col sm:flex-row gap-6 sm:gap-12">
							<div className="flex flex-col gap-3">
								<div className="uppercase tracking-wider mb-1">
									<Typography color="white" size={12} weight="semibold">
										Legal
									</Typography>
								</div>
								<Link
									to={'/terms-conditions'}
									className="cursor-pointer group flex items-center gap-2 w-fit"
								>
									<span className="group-hover:underline transition-all duration-200">
										<Typography color="white" size={14}>
											Términos y Condiciones
										</Typography>
									</span>
									<ExternalLink className="w-3 h-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
								</Link>
								<Link to={'privacy'} className="cursor-pointer group flex items-center gap-2 w-fit">
									<span className="group-hover:underline transition-all duration-200">
										<Typography color="white" size={14}>
											Aviso de Privacidad
										</Typography>
									</span>
									<ExternalLink className="w-3 h-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
								</Link>
								<Link
									to={'credit-operation'}
									className="cursor-pointer group flex items-center gap-2 w-fit"
								>
									<span className="group-hover:underline transition-all duration-200">
										<Typography color="white" size={14}>
											Operación Crediticia
										</Typography>
									</span>
									<ExternalLink className="w-3 h-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
								</Link>
							</div>
						</div>
						<div className="pt-4 border-t border-white/20 opacity-90">
							<Typography color="white" size={12}>
								© 2025 Fincluyente. Todos los derechos reservados.
							</Typography>
						</div>
					</div>
				</div>
				<div className="flex flex-col md:flex-row gap-8 md:gap-12">
					<div className="flex flex-col gap-4">
						<div className="uppercase tracking-wider mb-1">
							<Typography color="white" size={12} weight="semibold">
								Soporte
							</Typography>
						</div>
						<Link to="/support" className="cursor-pointer group flex items-center gap-2 w-fit">
							<span className="group-hover:underline transition-all duration-200">
								<Typography color="white" size={14}>
									Solicitud de soporte
								</Typography>
							</span>
							<ExternalLink className="w-3 h-3 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
						</Link>
						<a
							href="mailto:soporte@fincluyente.com"
							className="cursor-pointer group flex items-center gap-2 w-fit"
						>
							<Mail className="w-4 h-4 text-white" />
							<span className="group-hover:underline transition-all duration-200">
								<Typography color="white" size={14}>
									soporte@fincluyente.com
								</Typography>
							</span>
						</a>
					</div>
					<div className="flex flex-col gap-4">
						<div className="uppercase tracking-wider mb-1">
							<Typography color="white" size={12} weight="semibold">
								Redes Sociales
							</Typography>
						</div>
						<div className="flex gap-4 items-center">
							<a
								href="https://www.instagram.com/finclu_mx?igsh=ZDd6bXZpNTF2ZmFp"
								target="_blank"
								rel="noopener noreferrer"
								className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-300 hover:scale-110"
							>
								<img src="/instagram-logo.svg" alt="Instagram" className="w-6 h-6" />
							</a>
							<a
								href="https://www.facebook.com/finclumx?mibextid=LQQJ4d"
								target="_blank"
								rel="noopener noreferrer"
								className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-300 hover:scale-110"
							>
								<img src="/facebook-logo.svg" alt="Facebook" className="w-6 h-6" />
							</a>
							<a
								href="https://www.tiktok.com/@fincluemprende?_t=8r7xUikYYXm&_r=1"
								target="_blank"
								rel="noopener noreferrer"
								className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-300 hover:scale-110"
							>
								<img src="/tiktok-logo.webp" alt="TikTok" width={24} height={24} />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Footer;
